import React, {useEffect, useState } from 'react';
import { Flipper, Flipped } from 'react-flip-toolkit'

import { ThreeInchDisk, ZipDisk } from './Diskettes';

let datas = [
	{
		'type' : 'Disquette 3" 1/2',
		'image' : <ThreeInchDisk/>,
		'dimensions' : '90mm x 94mm x 5mm',
		'variants' : [
			{
				'name' : 'simple face',
				'value' : '0.36',
				'valueLabel' : '360 Ko',
			},
			{
				'name' : 'double densité',
				'value' : '0.72',
				'valueLabel' : '720 Ko',
			},
			{
				'name' : 'haute définition',
				'value' : '1.44',
				'valueLabel' : '1440 Ko',
			}
		]
	},
	{
		'type' : 'Disquette Zip',
		'image' : <ZipDisk/>,
		'dimensions' : '00mm x 00mm x 0mm',
		'variants' : [
			{
				'name' : '',
				'value' : '100',
				'valueLabel' : '100 Mo',
			},
			{
				'name' : '',
				'value' : '250',
				'valueLabel' : '250 Mo',
			},
			{
				'name' : '',
				'value' : '750',
				'valueLabel' : '750 Mo',
			}
		]
	}
]

const DisquetteControl = (props) => {
	const [fullScreen, setFullScreen] = useState(false);

	// const [stockage, setStockage] = useState(0);
	// const [selectedCompression, setSelectedCompression] = useState(false);
	// const [selectedFloppyDisk, setSelectedFloppyDisk] = useState(false);

	const toggleFullScreen = () => setFullScreen(prevState => !prevState);
	  
	let [defaultDisk, setDefaultDisk] = useState({
		'image' : <ThreeInchDisk/>,
		'value' : '0.72',
		'valueLabel' : '720 ko',
		'title' : 'Disquette 3.5 pouces',
		'dimensions' : '90mm x 94mm x 5mm',
	});

	const setItem = (event, item) => {
		event.preventDefault();
		setDefaultDisk(item);
		setFullScreen(prevState => !prevState);
	};

	const buildItem = (item, variant) => {
		return ({
			'image' : item.image,
			'value' : variant.value,
			'valueLabel' : variant.valueLabel,
			'title' : item.type,
			'dimensions' : item.dimensions,
		})
	}


	useEffect(() => {
		let $disquetteTypeSelect = document.querySelector('.disquette-type-select');
		$disquetteTypeSelect.value = defaultDisk.value;
	}, [defaultDisk]);

	const DisquetteSelectorContent = () => (datas.map((item, i) => (
		<div className="disquette-type-wrapper" key={i}>
			{item.image}
			<div className="caption">
				<h2>{item.type}</h2>
				<span className="dimensions">{item.dimensions}</span>
			</div>
			<div className="variants">
				{item.variants.map((variant, i) => (
					<button key={i} className={`disquette-variant ${variant.value === defaultDisk.value ? 'current' : ''}`} data-value={buildItem(item, variant)} onClick={(event) => setItem(event, buildItem(item, variant))}>
						<span className="name">{variant.name}</span>
						<span className="value">{variant.valueLabel}</span>
					</button>
				))}
			</div>
		</div>
	)));


	const DisquetteSelector = ({ toggleFullScreen }) => (
		<Flipped flipId="selectDisk">
			<div className="disquette-selector">
				<button className="closeSelector" onClick={toggleFullScreen}>Retour</button>
				<div className="disquette-selector-wrapper">
					<DisquetteSelectorContent />
				</div>
			</div>
		</Flipped>
	);

	const DisquetteSelectoed = ({ toggleFullScreen }) => (
		<Flipped flipId="selectDisk">
			<div className="disquette-selected">
				<div className="disquette-selected-item" onClick={toggleFullScreen}>
					{defaultDisk.image}
					<div className="caption">
						<span className="title">{defaultDisk.title}</span>
						<span className="capacity">Haute définition = {defaultDisk.valueLabel}</span>
						<span className="dimensions">{defaultDisk.dimensions}</span>
						<span className="changeLink">Changer</span>
					</div>
				</div>
			</div>
		</Flipped>
	);



  return (
	<React.Fragment>
			<Flipper flipKey={fullScreen}>
				{fullScreen ? (
					<DisquetteSelector toggleFullScreen={toggleFullScreen}/>
				) : (
					<DisquetteSelectoed toggleFullScreen={toggleFullScreen}/>
				)}
			</Flipper>

			<select name="disk-type" defaultValue={defaultDisk.value} className="hidden-select disquette-type-select">
				<option value="0.36">Disquette 3" 1/2 - 360 KO</option>
				<option value="0.72">Disquette 3" 1/2 - 720 KO</option>
				<option value="1.44">Disquette 3" 1/2 - 1440 KO</option>
				<option value="100">Disquette Zip - 100 MO</option>
				<option value="250">Disquette Zip - 250 MO</option>
				<option value="750">Disquette Zip - 750 MO</option>
				<option value="1000">CD Rom - 1 GO</option>
				<option value="4000">DVD - 4 GO</option>
			</select>
	</React.Fragment>
  );
}

export default DisquetteControl;
